import * as ComboActions from './combosActions';
import * as ComboReportActions from './combosReportActions';

const Actions = {
  ...ComboActions,
  ...ComboReportActions,
};

export default Actions;
